import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  shouldLeaveHandheld,
  shouldRedirectToFloor,
} from "../../helpers/handheldMode";
import { readWorkstationMode } from "../../helpers/workstationMode";

/**
 * On a warehouse PDA, open the welcome screen instead of desktop Batches.
 * Admins and staff only. Sellers stay in the normal app.
 * Stay on QC Regular (`/batch-item`) when that computer is the QC station.
 */
const ScannerHomeGate = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useSelector((s) => s?.currentUser?.user || null);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!user?.uid) return;
    if (
      shouldLeaveHandheld({
        user,
        pathname: location.pathname,
        search: location.search,
      })
    ) {
      navigate("/dashboard", { replace: true });
      return;
    }
    const go = shouldRedirectToFloor({
      pathname: location.pathname,
      search: location.search,
      userAgent: navigator.userAgent || "",
      screenWidth: window.screen?.width,
      screenHeight: window.screen?.height,
      innerWidth: window.innerWidth,
      innerHeight: window.innerHeight,
      devicePixelRatio: window.devicePixelRatio,
      workstationMode: readWorkstationMode(),
      user,
    });
    if (go) {
      navigate("/handheld", { replace: true });
    }
  }, [location.pathname, location.search, navigate, user]);

  return null;
};

export default ScannerHomeGate;
